import StoreIcon from "@mui/icons-material/Store";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import { MooneIcon } from "Components/Shared/Icons/MooneIcon";
import type { ReactNode } from "react";

export const MERCHANT_COMPLETE_REGISTRATION_PAGE_STEPS_IDS = [
  "party",
  "notes",
  "products",
  "facilities",
  "completion",
] as const;

export type MerchantCompleteRegistrationPageStepID =
  (typeof MERCHANT_COMPLETE_REGISTRATION_PAGE_STEPS_IDS)[number];

export const STEP_TO_ICON: Record<
  MerchantCompleteRegistrationPageStepID,
  ReactNode
> = {
  party: <PersonOutlineIcon />,
  notes: <EditNoteIcon />,
  facilities: <StoreIcon />,
  products: <MooneIcon />,
  completion: <ForwardToInboxIcon />,
};
